import(/* webpackMode: "eager", webpackExports: ["BlogIndexPanel"] */ "/workspace/src/components/public/blog-panels.tsx");
